const API = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers
    },
    body: options.body ? JSON.stringify(options.body) : undefined
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.reload();
    return null;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro na requisição');
  return data;
}

export const api = {
  login: (email, senha) => request('/auth/login', { method: 'POST', body: { email, senha } }),
  me: () => request('/auth/me'),
  
  getProdutos: () => request('/produtos'),
  createProduto: (d) => request('/produtos', { method: 'POST', body: d }),
  updateProduto: (id, d) => request(`/produtos/${id}`, { method: 'PUT', body: d }),
  deleteProduto: (id) => request(`/produtos/${id}`, { method: 'DELETE' }),

  getVendas: () => request('/vendas'),
  createVenda: (d) => request('/vendas', { method: 'POST', body: d }),

  getCompras: () => request('/compras'),
  createCompra: (d) => request('/compras', { method: 'POST', body: d }),
  updateCompra: (id, d) => request(`/compras/${id}`, { method: 'PUT', body: d }),
  entradaEstoque: (id, d) => request(`/compras/${id}/entrada`, { method: 'POST', body: d }),

  getClientes: () => request('/clientes'),
  createCliente: (d) => request('/clientes', { method: 'POST', body: d }),
  receberFiado: (id) => request(`/clientes/${id}/receber`, { method: 'PATCH' }),

  getEncomendas: () => request('/encomendas'),
  createEncomenda: (d) => request('/encomendas', { method: 'POST', body: d }),

  getUsuarios: () => request('/usuarios'),
  createUsuario: (d) => request('/usuarios', { method: 'POST', body: d }),
  updateUsuario: (id, d) => request(`/usuarios/${id}`, { method: 'PUT', body: d }),
  toggleUsuario: (id) => request(`/usuarios/${id}/toggle`, { method: 'PATCH' }),
  presaleSummary: () => request('/admin/store/presale/summary'),
  getPresaleProducts: () => request('/admin/store/presale/products'),
  createPresaleProduct: (d) => request('/admin/store/presale/products', { method: 'POST', body: d }),
  updatePresaleProduct: (id, d) => request('/admin/store/presale/products/' + id, { method: 'PUT', body: d }),
  deletePresaleProduct: (id) => request('/admin/store/presale/products/' + id, { method: 'DELETE' }),
  getPresaleReservations: () => request('/admin/store/presale/reservations'),
  createPresaleReservation: (d) => request('/admin/store/presale/reservations', { method: 'POST', body: d }),
  updatePresaleReservation: (id, d) => request('/admin/store/presale/reservations/' + id, { method: 'PUT', body: d }),
  deletePresaleReservation: (id) => request('/admin/store/presale/reservations/' + id, { method: 'DELETE' }),
  presaleReceipt: (clientName) => {
    const token = localStorage.getItem('token');
    return fetch('/api/admin/store/presale/receipt?client_name=' + encodeURIComponent(clientName), {
      headers: token ? { Authorization: 'Bearer ' + token } : {}
    }).then(r => {
      if (!r.ok) throw new Error('Erro ao gerar PDF');
      return r.blob();
    }).then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'reserva_' + clientName.replace(/[^a-zA-Z0-9]/g, '_') + '.pdf';
      a.click();
      URL.revokeObjectURL(url);
    });
  },
  togglePresaleDelivered: (id) => request('/admin/store/presale/reservations/' + id + '/delivered', { method: 'PATCH' }),
};
